import script from "./CashRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./CashRegister.vue?vue&type=script&setup=true&lang=js"

import "./CashRegister.vue?vue&type=style&index=0&id=5c85d366&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c85d366"]])

export default __exports__